export default {
  reset: (state) => {
    state.item = {
      logo: null,
      name: null,
    };
    state.isLoading = false;
  },
  setItem: (state, item) => {
    state.item = item;
  },
  setIsLoading: (state, isLoading) => {
    state.isLoading = isLoading;
  },
};
